import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ReportingCompanySearchService } from '@http/clients/reporting-app/reporting-company-search.service';
import { GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../../custom-menu-item/custom-menu-item.component';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-company-form-editor',
    templateUrl: './report-company-form-editor.component.html',
    styleUrls: ['./report-company-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportCompanyFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class ReportCompanyFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Companies');
    placeholderText = input<string>('Search Companies');

    private readonly companySearchService = inject(ReportingCompanySearchService);

    async ngOnInit(): Promise<void> {
        const selectedIds = this.selectedValue();
        if (selectedIds?.length) {
            const selected = await this.companySearchService.getByIds(selectedIds);
            this.selectedItems.set(selected);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text?.trim()) {
            this.items.set([]);
            return;
        }
        const companies = await this.companySearchService.search(text);
        this.items.set(companies);
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(): any[] {
        return this.selectedItems() ?? [];
    }
}
